{
  "name": "iobroker.rssfeed",
  "version": "5.0.2",
  "description": "Adapter and vis widget for rss feeds",
  "author": {
    "name": "oweitman",
    "email": "oweitman@gmx.de"
  },
  "homepage": "https://github.com/oweitman/ioBroker.rssfeed",
  "license": "MIT",
  "keywords": [
    "ioBroker",
    "rss",
    "atom",
    "rdf",
    "feed"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/oweitman/ioBroker.rssfeed.git"
  },
  "engines": {
    "node": ">=22"
  },
  "dependencies": {
    "@iobroker/adapter-core": "^3.4.3",
    "axios": "^1.17.0",
    "chardet": "^2.1.1",
    "feedparser": "^2.6.0",
    "iconv-lite": "^0.7.3"
  },
  "devDependencies": {
    "@alcalzone/release-script": "^5.2.1",
    "@alcalzone/release-script-plugin-iobroker": "^5.2.0",
    "@alcalzone/release-script-plugin-license": "^5.2.2",
    "@alcalzone/release-script-plugin-manual-review": "^5.2.0",
    "@iobroker/adapter-dev": "^1.5.0",
    "@iobroker/build-tools": "^3.0.1",
    "@iobroker/eslint-config": "^2.3.4",
    "@iobroker/testing": "^5.3.0",
    "@tsconfig/node22": "^22.0.6",
    "@types/node": "^22.20.1",
    "@types/proxyquire": "^1.3.31",
    "proxyquire": "^2.1.3",
    "typescript": "~5.9.3"
  },
  "main": "main.js",
  "files": [
    "admin{,/!(src)/**}/!(tsconfig|tsconfig.*|eslint.config.mjs|prettier.config.mjs).{json,json5}",
    "admin{,/!(src)/**}/*.{html,css,png,svg,jpg,js}",
    "lib/",
    "widgets/rssfeed.html",
    "widgets/rssfeed/css/*.css",
    "widgets/rssfeed/dist/*.{css,js,map}",
    "widgets/rssfeed/img/*.{png,svg,jpg}",
    "widgets/rssfeed/js/mode-ejs.js",
    "widgets/rssfeed/myi18n/translations.json",
    "widgets/vis2rssfeed/**/*.{css,json,map,png,svg,jpg,js}",
    "www/",
    "io-package.json",
    "LICENSE",
    "main.js"
  ],
  "scripts": {
    "test:js": "mocha --config test/mocharc.custom.json \"{!(node_modules|test)/**/*.test.js,*.test.js,test/**/test!(PackageFiles|Startup).js}\"",
    "test:package": "mocha test/package --exit",
    "test:integration": "mocha test/integration --exit",
    "test": "npm run test:integration && npm run test:package",
    "check": "tsc --noEmit -p tsconfig.check.json",
    "lint": "npm run lint-adapter && npm run lint-vis2widgets && npm run lint-vis1widgets",
    "lint-adapter": "eslint -c eslint.config.mjs main.js lib",
    "lint-vis2widgets": "npm run lint --prefix src-widgets",
    "lint-vis1widgets": "eslint -c eslint.config.mjs widgets/rssfeed/js",
    "build-vis1widgets": "npm run build --prefix widgets",
    "build-vis2widgets": "node tasks --javascript-vite",
    "build": "npm run build-vis1widgets && npm run build-vis2widgets",
    "dev:upload": "dev-server upload",
    "dev:run": "dev-server run",
    "dev:watch": "dev-server watch --noStart",
    "dev:watchvis2widgets": "npm run start --prefix src-widgets",
    "dev:watchvis1widgets": "npm run watch --prefix widgets",
    "prepublishOnly": "npm run build",
    "npm": "npm i && npm i --prefix widgets && npm i --prefix src-widgets",
    "npmci": "npm ci && npm ci --prefix widgets && npm ci --prefix src-widgets",
    "repochecker": "npx @iobroker/repochecker https://github.com/oweitman/ioBroker.rssfeed --noinfo",
    "translate": "translate-adapter",
    "translate-widgets": "node ./bin/translate.js --source widgets/rssfeed/myi18n/en.json --format single",
    "translate-widgets-vis2": "node ./bin/translate.js --source src-widgets/src/i18n/",
    "release": "release-script --all"
  },
  "bugs": {
    "url": "https://github.com/oweitman/ioBroker.rssfeed/issues"
  },
  "readmeFilename": "README.md"
}
